import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import {DescriptionModalComponent} from "../description-modal/description-modal.component";
import {CommercialDTO, EventDTO, ExploreDTO, XploreItemDTO} from "../../../shared/object/xplorer-be-parsed-classes";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import {TabComponent} from "../tab/tab.component";
import { RelatedItemsManagerComponent } from '../related-items-manager/related-items-manager.component';
import { FacebookInfoItemComponent } from '../info-items/facebook-info-item/facebook-info-item.component';
import { InstagramInfoItemComponent } from '../info-items/instagram-info-item/instagram-info-item.component';
import { HourInfoItemComponent } from '../info-items/hour-info-item/hour-info-item.component';
import { DateInfoItemComponent } from '../info-items/date-info-item/date-info-item.component';
import { EmailInfoItemComponent } from '../info-items/email-info-item/email-info-item.component';
import { PhoneInfoItemComponent } from '../info-items/phone-info-item/phone-info-item.component';
import { PriceInfoItemComponent } from '../info-items/price-info-item/price-info-item.component';
import { WebsiteInfoItemComponent } from '../info-items/website-info-item/website-info-item.component';
import { LocationInfoItemComponent } from '../info-items/location-info-item/location-info-item.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.css'],
    imports: [NgClass, TabComponent, DescriptionModalComponent, LocationInfoItemComponent, WebsiteInfoItemComponent, PriceInfoItemComponent, PhoneInfoItemComponent, EmailInfoItemComponent, DateInfoItemComponent, HourInfoItemComponent, InstagramInfoItemComponent, FacebookInfoItemComponent, RelatedItemsManagerComponent, TranslateModule]
})
export class InfoBoxComponent implements OnInit {

  @ViewChild('descriptionTab', {static: true})
  descriptionTab: TabComponent;

  @ViewChild('infoTab', {static: true})
  infoTab: TabComponent;

  @ViewChild('relatedTab', {static: true})
  relatedTab: TabComponent;

  tabs: TabComponent[] = [];

  @Input()
  xploreItem: XploreItemDTO;
  isDescriptionModalOpen = false;

  private translation: TranslateService = inject(TranslateService);


  ngOnInit(): void {
    this.tabs.forEach(tab => tab.active = false);
    this.descriptionTab.active = true;
    this.tabs.push(this.descriptionTab);
    this.tabs.push(this.infoTab);
    this.tabs.push(this.relatedTab);
  }

  selectTab(tab: TabComponent) {
    this.tabs.forEach(tab => tab.active = false);
    tab.active = true;
  }

  getDescription() {
    switch (this.translation.currentLang) {
      case 'it':
        return this.xploreItem.descriptionFormatted != null ? this.xploreItem.descriptionFormatted : this.xploreItem.description;
      case 'en':
        return this.xploreItem.descriptionEngFormatted != null ? this.xploreItem.descriptionEngFormatted : this.xploreItem.descriptionEng;
      default:
        return this.xploreItem.descriptionFormatted != null ? this.xploreItem.descriptionFormatted : this.xploreItem.description;
    }
  }

  getShortDescription() {
    switch (this.translation.currentLang) {
      case 'it':
        return this.xploreItem.shortDescription;
      case 'en':
        return this.xploreItem.shortDescriptionEng;
      default:
        return this.xploreItem.shortDescription;
    }
  }

  open() {
    this.isDescriptionModalOpen = true;
  }

  closeDescriptionModal() {
    this.isDescriptionModalOpen = false;
  }

  getPositionName() {
    return this.xploreItem.geoPositionDTO.via + " " + this.xploreItem.geoPositionDTO.numeroCivico + " - " + this.xploreItem.geoPositionDTO.comune.name
  }

  getPrice() {
    if (this.xploreItem.itemType === 'COMMERCIAL') {
      let commercial = this.xploreItem as CommercialDTO
      return commercial.price
    } else if(this.xploreItem.itemType === 'EVENT') {
      let event = this.xploreItem as EventDTO
      return event.price
    } else {
      return undefined
    }
  }

  hasDate() {
    if (this.xploreItem.itemType === "EXPLORE") {
      const explore = this.xploreItem as ExploreDTO
      return (explore.openDate !== null || explore.closeDate !== null)
    } else if (this.xploreItem.itemType === "COMMERCIAL") {
      const commercial = this.xploreItem as CommercialDTO
      return (commercial.openDate || commercial.closeDate)
    } else if(this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return (event.date !== undefined)
    } else {
      return false
    }
  }

  getOpenDate() {
    if (this.xploreItem.itemType === "EXPLORE") {
      const explore = this.xploreItem as ExploreDTO
      return new Date(explore.openDate)
    } else if (this.xploreItem.itemType === "COMMERCIAL") {
      const commercial = this.xploreItem as CommercialDTO
      return new Date(commercial.openDate)
    } else if(this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return new Date(event.date)
    } else {
      throw new Error("Invalid item type" + this.xploreItem.itemType)
    }
  }

  isEvent() {
    return this.xploreItem.itemType === "EVENT"
  }

  getCloseDate() {
    if (this.xploreItem.itemType === "EXPLORE") {
      const explore = this.xploreItem as ExploreDTO
      return new Date(explore.closeDate)
    } else if (this.xploreItem.itemType === "COMMERCIAL") {
      const commercial = this.xploreItem as CommercialDTO
      return new Date(commercial.closeDate)
    } else if(this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return new Date(event.date)
    } else {
      throw new Error("Invalid item type" + this.xploreItem.itemType)
    }
  }

  hasHour() {
    if (this.xploreItem.itemType === "EXPLORE") {
      const explore = this.xploreItem as ExploreDTO
      return (explore.openHour !== null || explore.closeHour !== null)
    } else if (this.xploreItem.itemType === "COMMERCIAL") {
      const commercial = this.xploreItem as CommercialDTO
      return (commercial.openHour !== undefined || commercial.closeHour !== undefined)
    } else if (this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return (event.openHour && event.closeHour)
    } else {
      return false
    }
  }

  getOpenHour() {
    if (this.xploreItem.itemType === "EXPLORE") {
      const explore = this.xploreItem as ExploreDTO
      return new Date(explore.openHour)
    } else if (this.xploreItem.itemType === "COMMERCIAL") {
      const commercial = this.xploreItem as CommercialDTO
      return new Date(commercial.openHour)
    } else if(this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return new Date(event.openHour)
    } else {
      throw new Error("Invalid item type" + this.xploreItem.itemType)
    }
  }

  getBookableUntil() {
    if (this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return new Date(event.lastBookingTime)
    }
    return null
  }

  getCloseHour() {
    if (this.xploreItem.itemType === "EXPLORE") {
      const explore = this.xploreItem as ExploreDTO
      return new Date(explore.closeHour)
    } else if (this.xploreItem.itemType === "COMMERCIAL") {
      const commercial = this.xploreItem as CommercialDTO
      return new Date(commercial.closeHour)
    } else if(this.xploreItem.itemType === "EVENT") {
      const event = this.xploreItem as EventDTO
      return new Date(event.closeHour)
    } else {
      throw new Error("Invalid item type" + this.xploreItem.itemType)
    }
  }

  isTabActive(tab: TabComponent) {
    return tab.active
  }
}
